import { formatCurrency, formatDate } from "../helper/helper";

const OvCard = ({ label, value, sub }) => (
  <div className="cpv__ov-card">
    <span className="cpv__ov-label">{label}</span>
    <span className="cpv__ov-value">{value ?? "N/A"}</span>
    {sub && <span className="cpv__ov-sub">{sub}</span>}
  </div>
);

const OverviewTab = ({ overview }) => {
  return (
    <div className="cpv__ov-grid">
      <OvCard
        label="LIFETIME VALUE"
        value={formatCurrency(overview?.lifetimeValue)}
        sub={`from ${overview?.totalOrders ?? "N/A"} orders`}
      />
      <OvCard
        label="TOTAL DISCOUNTS"
        value={formatCurrency(overview?.totalDiscounts)}
        sub={`from ${overview?.totalOrders ?? "N/A"} orders`}
      />
      <OvCard
        label="CUSTOMER RANKING"
        value={overview?.customerRanking ?? "N/A / N/A"}
        sub="based on sales value"
      />
      <OvCard
        label="AVERAGE CART VALUE"
        value={formatCurrency(overview?.averageCartValue)}
        sub={`from ${overview?.totalOrders ?? "N/A"} orders`}
      />
      <OvCard
        label="LAST SALE"
        value={formatCurrency(overview?.lastSaleAmount)}
        sub={overview?.lastSaleDate ? formatDate(overview?.lastSaleDate) : "N/A"}
      />
      <OvCard
        label="FAVORITE CATEGORY"
        value={overview?.favoriteCategory ?? "N/A"}
        sub={overview?.visitGap ? `visit gap ${overview?.visitGap} days` : ""}
      />
    </div>
  );
};

export default OverviewTab;
